import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
  ODataDecimal,
} from "pbas-vue-components";

import { translate } from "../trans";
import store from "@/store";
function formatDate(dateString) {
  if (dateString === undefined || dateString === null) {
    return "";
  }
  const [date, time] = dateString.split("T");
  const [year, month, day] = date.split("-");
  return `${year}-${month}-${day}`;
}
const pensionBeneficiariesHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.search_beneficiaries.beneficiary_spouse_id",
    type: new ODataString("PensionBeneficiaryId"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  // new ODataHeader({
  //   title: "globals.type",
  //   type: new ODataString("BeneficiaryType"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 1,
  // }),
  // new ODataHeader({
  //   type: new ODataString("BeneficiaryType/Translations[]/LanguageCode"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "globals.type",
  //   type: new ODataString("BeneficiaryType/Translations[]/DisplayValue", {
  //     getString: (item) => {
  //       if (!item) return "";
  //       const lang = store.getters["common/language"];
  //       return translate(item.BeneficiaryType, lang.language);
  //     },
  //   }),
  //   visible: true,
  //   searchable: true,
  //   sortable: true,
  //   orderByKey: "BeneficiaryType/Name",
  //   version: 1,
  // }),
  // new ODataHeader({
  //   title: "Beneficiary Type Id",
  //   type: new ODataString("BeneficiaryType/Id"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "BeneficiaryTypeId",
  //   type: new ODataString("BeneficiaryTypeId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString("BeneficiaryRelationship/Name"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 1,
  // }),
  // new ODataHeader({
  //   type: new ODataString(
  //     "BeneficiaryRelationship/Translations[]/LanguageCode"
  //   ),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString(
  //     "BeneficiaryRelationship/Translations[]/DisplayValue",
  //     {
  //       getString: (item) => {
  //         if (!item) return "";
  //         const lang = store.getters["common/language"];
  //         return translate(item.BeneficiaryRelationship, lang.language);
  //       },
  //     }
  //   ),
  //   visible: true,
  //   searchable: true,
  //   sortable: true,
  //   orderByKey: "BeneficiaryRelationship/Name",
  //   version: 1,
  // }),
  // new ODataHeader({
  //   title: "Beneficiary Relationship Id",
  //   type: new ODataString("BeneficiaryRelationship/Id"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "BeneficiaryRelationshipId",
  //   type: new ODataString("BeneficiaryRelationshipId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    type: new ODataBoolean("BeneficiaryRelationship/IsSpouse"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataBoolean("BeneficiaryRelationship/IsChild"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("DependantIdentity/Current/LastName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("DependantIdentity/Current/FirstName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataDate("DependantIdentity/Current/DateOfBirth"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataDate("BeneficiaryStatement/MemberIdentityId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("LastName", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity && item.DependantIdentity.Current) {
            return item.DependantIdentity.Current.LastName;
          }
        }
        return item.LastName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("FirstName", {
      getString: (item) => {
        console.log(item);
        if (!item) return "";
        if (!item.BeneficiaryRelationship) return item.FirstName;
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity && item.DependantIdentity.Current) {
            return item.DependantIdentity.Current.FirstName;
          }
        }
        return item.FirstName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.members_management.SIN",
    type: new ODataString("SIN"),
    sortable: true,
  }),
  new ODataHeader({
    title: "globals.dob",
    type: new ODataDate("DateOfBirth", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          console.log(item);
          if (item.DependantIdentity && item.DependantIdentity.Current) {
            return formatDate(item.DependantIdentity.Current.DateOfBirth);
          }
          return formatDate(item.DateOfBirth);
        }
        return item.DateOfBirth;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const hwBeneficiariesHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  // new ODataHeader({
  //   title: "globals.type",
  //   type: new ODataString("BeneficiaryType"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 1,
  // }),
  // new ODataHeader({
  //   type: new ODataString("BeneficiaryType/Translations[]/LanguageCode"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "globals.type",
  //   type: new ODataString("BeneficiaryType/Translations[]/DisplayValue", {
  //     getString: (item) => {
  //       if (!item) return "";
  //       const lang = store.getters["common/language"];
  //       return translate(item.BeneficiaryType, lang.language);
  //     },
  //   }),
  //   visible: true,
  //   searchable: true,
  //   sortable: true,
  //   orderByKey: "BeneficiaryType/Name",
  //   version: 1,
  // }),
  // new ODataHeader({
  //   title: "Beneficiary Type Id",
  //   type: new ODataString("BeneficiaryType/Id"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "BeneficiaryTypeId",
  //   type: new ODataString("BeneficiaryTypeId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString("BeneficiaryRelationship/Name"),
  //   sortable: true,
  //   visible: false,
  //   searchable: true,
  //   allowVisibilityChange: false,
  //   version: 1,
  // }),
  // new ODataHeader({
  //   type: new ODataString(
  //     "BeneficiaryRelationship/Translations[]/LanguageCode"
  //   ),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "components.inmemorydependants.relationship",
  //   type: new ODataString(
  //     "BeneficiaryRelationship/Translations[]/DisplayValue",
  //     {
  //       getString: (item) => {
  //         if (!item) return "";
  //         const lang = store.getters["common/language"];
  //         return translate(item.BeneficiaryRelationship, lang.language);
  //       },
  //     }
  //   ),
  //   visible: true,
  //   searchable: true,
  //   sortable: true,
  //   orderByKey: "BeneficiaryRelationship/Name",
  //   version: 1,
  // }),
  // new ODataHeader({
  //   title: "Beneficiary Relationship Id",
  //   type: new ODataString("BeneficiaryRelationship/Id"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new ODataHeader({
  //   title: "BeneficiaryRelationshipId",
  //   type: new ODataString("BeneficiaryRelationshipId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    type: new ODataBoolean("BeneficiaryRelationship/IsSpouse"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataBoolean("BeneficiaryRelationship/IsChild"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("DependantIdentity/Current/LastName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("DependantIdentity/Current/FirstName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataDate("DependantIdentity/Current/DateOfBirth"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  // new ODataHeader({
  //   type: new ODataDate("MemberIdentityId"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("LastName", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity && item.DependantIdentity.Current) {
            return item.DependantIdentity.Current.LastName;
          }
        }
        return item.LastName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("FirstName", {
      getString: (item) => {
        console.log(item);
        if (!item) return "";
        if (!item.BeneficiaryRelationship) return item.FirstName;
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          if (item.DependantIdentity && item.DependantIdentity.Current) {
            return item.DependantIdentity.Current.FirstName;
          }
        }
        return item.FirstName;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.members_management.SIN",
    type: new ODataString("SIN"),
    sortable: true,
  }),
  new ODataHeader({
    title: "globals.dob",
    type: new ODataDate("DateOfBirth", {
      getString: (item) => {
        if (!item || !item.BeneficiaryRelationship) return "";
        if (
          item.BeneficiaryRelationship.IsSpouse ||
          item.BeneficiaryRelationship.IsChild
        ) {
          console.log(item);
          if (item.DependantIdentity && item.DependantIdentity.Current) {
            return formatDate(item.DependantIdentity.Current.DateOfBirth);
          }
          return formatDate(item.DateOfBirth);
        }
        return item.DateOfBirth;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
function getBeneficiariesHeaders(planType) {
  if (planType === "Pension") {
    return pensionBeneficiariesHeaders;
  }
  return hwBeneficiariesHeaders;
}
export default getBeneficiariesHeaders;
